module.exports = __webpack_public_path__ + "img/BSN0601.83f92f2a.png";